@if (user ) {
  <div class="wrapper has-padding reset-password">
    <h4 class="bofa--heading is-4">Reset Password</h4>
    <form [formGroup]="resetPasswordGroup" (ngSubmit)="onSubmit()">
      <mat-form-field class="max-zoom user-name">
        <mat-label>Username</mat-label>
        <input matInput value="{{email}}" disabled>
      </mat-form-field>
      <div>
        <mat-form-field class="zoom-padding-bottom new-password">
          <mat-label>New password</mat-label>
          <input matInput formControlName="newPassword" placeholder="" (focus)="showHint()" (blur)="showHint()"
            [type]="hide ? 'password' : 'text'" maxlength="20" required autocomplete="off">
          <mat-hint>
            <div class="bofa--skiplink">
              <!-- Hidden divs are for screen readers -->
              <span>Rules:</span>
              <ul>
                <li>Minimum 8 characters long, Maximum of 20</li>
                <li>No special characters allowed: &, $, %, etc.</li>
                <li>At least one letter (a.k.a. alphabetic character)</li>
                <li>At least one number (a.k.a. numeric character)</li>
                <li>Cannot be your username</li>
                <li>Cannot be the previous 16 passwords</li>
              </ul>
            </div>
          </mat-hint>
          <mat-error>Please enter new password
            <div class="bofa--skiplink">
              <!-- Hidden divs are for screen readers -->
              <span>Rules:</span>
              <ul>
                <li>Minimum 8 characters long, Maximum of 20</li>
                <li>No special characters allowed: &, $, %, etc.</li>
                <li>At least one letter (a.k.a. alphabetic character)</li>
                <li>At least one number (a.k.a. numeric character)</li>
                <li>Cannot be your username</li>
                <li>Cannot be the previous 16 passwords</li>
              </ul>
            </div>
          </mat-error>
        </mat-form-field>
        <button type="button" class="bofa--button secondary outlined zoom-width flex-space" (click)="hide = !hide"
        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">{{hide ? 'Show' : 'Hide'}}</button>
        <button (click)="generatePassword()" type="Button" class="bofa--button secondary">Generate new strong
        password</button>
      </div>
      @if (showPasswordHint) {
        <div
          class="has-background cool-gray-5 has-padding is-stacked item bofa--form_field large max-zoom min-font">
          <label for="rules">Rules</label>
          <ul class="list-reset" id="rules">
            <ul class="list-reset">
              <li>
                <label><input type="checkbox" [checked]="newPassword.value && (newPassword.value.length>=8 && newPassword.value.length<=20)"
                disabled />Minimum 8 characters long, Maximum of 20</label>
              </li>
              <li>
                <label><input type="checkbox" [checked]="newPassword.value && checkSpecialCharacters(newPassword.value)"
                disabled />No special characters allowed: &, $, %, etc.</label>
              </li>
              <li>
                <label><input type="checkbox" [checked]="newPassword.value && checkAlphaCharacter(newPassword.value)"
                disabled />At least one letter (a.k.a. alphabetic character)</label>
              </li>
              <li>
                <label><input type="checkbox" [checked]="newPassword.value && checkNumeric(newPassword.value) "
                disabled />At least one number (a.k.a. numeric character)</label>
              </li>
              <li>
                <label><input type="checkbox" [checked]="newPassword.value && (newPassword.value != user.email) "
                disabled />Cannot be your username</label>
              </li>
              <li>
                <label class="padd-20">Cannot be the previous 16 passwords</label>
              </li>
            </ul>
          </ul>
        </div>
      }
      <mat-form-field class="renter-password">
        <mat-label>Re-enter new password</mat-label>
        <input matInput formControlName="confirmPassword" type="password" (focus)="showHintTwo()" (blur)="showHintTwo()"
          maxlength="20" required autocomplete="off">
        <mat-hint>
          <div class="bofa--skiplink">
            Rules: must match previously entered password
          </div>
        </mat-hint>
        @if (confirmPassword.hasError('required') || confirmPassword.hasError('noMatch')) {
          <mat-error>Please re-enter
            password
            <div class="bofa--skiplink">
              Rules: must match previously entered password
            </div>
          </mat-error>
        }
      </mat-form-field>
      @if (showReEnterPasswordHint) {
        <div
          class="has-background cool-gray-5 has-padding is-stacked bofa--form_field large max-zoom min-font">
          <label for="rules1">Rules</label>
          <ul class="list-reset" id="rules1">
            <li class="checkbox-custom right">
              <label><input type="checkbox" disabled [checked]="confirmPassword.value==newPassword.value" />Must match
              previously entered password</label>
            </li>
          </ul>
        </div>
      }
      <div class="bofa--action_bar is-taller">
        <button class="bofa--button primary large" [disabled]="!resetPasswordGroup.valid">Save my new password</button>
      </div>
    </form>
    <p class="is-taller item"><a routerLink="/login" class="bofa--button reverse">&larr; Back</a></p>
  </div>
} @else {
  Applicant Does Not Exist
}
